import React, { useEffect } from "react";
import { Outlet } from "react-router";
import { ScrollToTopComponent } from "./components/scroll-to-top.component";
import { FooterContainerComponent } from "./footer/footer-container.component";
import { HeaderComponent } from "./header/header.component";

interface IContainerComponentProps {}

export const ContainerComponent: React.FC<IContainerComponentProps> = (
    props: IContainerComponentProps
) => {
    function toggleScrollTop(scrollTop: any) {
        if (scrollTop) {
            window.scrollY > 100
                ? scrollTop.classList.add("active")
                : scrollTop.classList.remove("active");
        }
    }

    useEffect(() => {
        const preloader = document.querySelector("#preloader");
        if (preloader) {
            preloader.remove();
        }

        let scrollTop = document.querySelector(".scroll-top");
        scrollTop?.addEventListener("click", (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
        window.addEventListener("load", () => {
            toggleScrollTop(scrollTop);
        });
        document.addEventListener("scroll", () => {
            toggleScrollTop(scrollTop);
        });
    }, []);

    return (
        <>
            <HeaderComponent />
            <main className="main">
                <Outlet />
            </main>
            <FooterContainerComponent />
            <ScrollToTopComponent />
            <div id="preloader"></div>
        </>
    );
};
